import apiClient from './apiClient'

export interface VocativeException {
  id: number
  firstName: string
  vocative: string
}

export const vocativeExceptionsService = {
  getAll: (): Promise<VocativeException[]> =>
    apiClient.get('/vocative-exceptions').then((r: { data: VocativeException[] }) => r.data),

  create: (firstName: string, vocative: string): Promise<VocativeException> =>
    apiClient.post('/vocative-exceptions', { firstName, vocative }).then((r: { data: VocativeException }) => r.data),

  update: (id: number, firstName: string, vocative: string): Promise<void> =>
    apiClient.put(`/vocative-exceptions/${id}`, { firstName, vocative }),

  delete: (id: number): Promise<void> =>
    apiClient.delete(`/vocative-exceptions/${id}`),
}
